module.exports = __webpack_public_path__ + "img/radio-selected.7deceb67.svg";